export const INTRO_OFFER_PERCENT = 45;

const formatCents = (cents) => `$${(cents / 100).toFixed(2)}`;

export const getIntroPricing = ({
  monthlyPrice,
  annualMonthlyPrice,
  billingPeriod,
  discountPercent = INTRO_OFFER_PERCENT,
}) => {
  const isAnnual = billingPeriod === 'annual';
  const unitPrice = isAnnual ? annualMonthlyPrice : monthlyPrice;
  const regularCents = Math.round(unitPrice * 100) * (isAnnual ? 12 : 1);
  const discountedCents = Math.round(
    regularCents * ((100 - discountPercent) / 100),
  );

  return {
    discountPercent,
    regularPrice: formatCents(regularCents),
    discountedPrice: formatCents(discountedCents),
    periodLabel: isAnnual ? 'first year' : 'first month',
    renewalPrice: `${formatCents(regularCents)}/${isAnnual ? 'year' : 'month'}`,
  };
};
